import { useEffect } from "react";
import { useSelector } from "react-redux";

import { setUserNumberFormatLocale } from "@utils/appUtils";

/**
 * Subscribe to the user's number-format preference so the calling component
 * re-renders whenever it changes, keeping formatted numbers in sync.
 */
const useNumberFormat = () => {
  const numberFormat = useSelector(state => state.userInfo?.data?.numberFormat);

  // Safety-net: keep the module-level locale in sync if the Redux value arrives
  // after the initial setUserNumberFormatLocale call (e.g. slow API response).
  useEffect(() => {
    setUserNumberFormatLocale(numberFormat);
  }, [numberFormat]);

  return numberFormat;
};

export default useNumberFormat;
